module.exports = __webpack_public_path__ + "static/media/money2.0d01fe2e.png";